export const baseUrl = 'https://uat-jkseeds-api.loyaltyprogramz.com/api/v1/' // Stage URL
export const av = "1.0";
export const pt = "WEBSITE";
export const company = "1"
export const program = "1"


